import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('AppAvatar').create(({ theme }) => ({
  root: {
    position: 'relative',
    display: 'flex',
    width: '35px',
    aspectRatio: '1/1',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.sizes.radiuses.xs,

    '&[data-subscriptionlevel="1"]': {
      border: '1px solid',
      zIndex: 2,
      borderColor: theme.colors.text.link,
    },
    '&[data-subscriptionlevel="2"]': {
      border: '1px solid',
      zIndex: 2,
      borderColor: theme.colors.text.primary,
    },
  },
}))
